var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fromStr || _vm.untilStr) ? _c('span', {
    staticClass: "revision-validity"
  }, [_c('span', {
    staticClass: "revision-validity__from"
  }, [_vm._v("\n    " + _vm._s(_vm.fromStr || '∞') + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "revision-validity__separator"
  }, [_vm._v("—")]), _vm._v(" "), _c('span', {
    staticClass: "revision-validity__until"
  }, [_vm._v("\n    " + _vm._s(_vm.untilStr || '∞') + "\n  ")])]) : _c('span', {
    staticClass: "revision-validity"
  }, [_vm._v("∞")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc73e2b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/RevisionValidity.vue
// module id = 2120
// module chunks = 0